<div class="copy-toast-container" [class.show]="show">
  <div class="copy-toast-content">
    <div class="copy-toast-icon">
      <i class="far" [ngClass]="icon"></i>
    </div>
    <div class="copy-toast-message">
      {{ message }}
    </div>
  </div>
</div>